import './MainCarousel.css';
import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel'; // Importing Carousel from react-bootstrap

function MainCarousel({ offers }) {
  return (
    <Carousel>
      {offers.map((offer, index) => (
        <Carousel.Item key={index}>
          <Link to={offer.link}>
            <img
              src={offer.imgHead}
              className="d-block w-100"
              alt={offer.title || "Slide"}
              style={{ height: '600px', objectFit: 'cover' }} // Ensure consistent image height
            />
            <Carousel.Caption>
              <h5>{offer.title}</h5>
              <p>{offer.text}</p>
            </Carousel.Caption>
          </Link>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default MainCarousel;
